import { render, staticRenderFns } from "./listAdd.vue?vue&type=template&id=03258058&scoped=true&"
import script from "./listAdd.vue?vue&type=script&lang=js&"
export * from "./listAdd.vue?vue&type=script&lang=js&"
import style0 from "./listAdd.vue?vue&type=style&index=0&id=03258058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03258058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03258058')) {
      api.createRecord('03258058', component.options)
    } else {
      api.reload('03258058', component.options)
    }
    module.hot.accept("./listAdd.vue?vue&type=template&id=03258058&scoped=true&", function () {
      api.rerender('03258058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/list/listAdd.vue"
export default component.exports